import templateUrl from "emun.customer/customer-notes-popup.htm";
import CustomerNotesPopupController from "emun.customer/customer-notes-popup.controller";
import open from "webmodals/open";

let CustomerNotesPopup = options => {
  let modalInstance = open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    controller: CustomerNotesPopupController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default CustomerNotesPopup;
